export type AbsenceCategorySummary = {
  hasYearlyBasedAccrualPolicy: boolean;
  isUnlimited: boolean;
  prevPeriod: PreviousPeriodSummary;
  curPeriod: CurrentPeriodSummary;
  nextPeriod: NextPeriodSummary;
};

export const PERIOD_TYPES = ['previous', 'current', 'next'] as const;

export type PeriodType = (typeof PERIOD_TYPES)[number];

export type PreviousPeriodSummary = {
  startDate: string;
  endDate: string;
  name: string;
  accrued: number | null; // null for Unlimited category
  allowances: AllowanceInfo[] | null; // null for Unlimited category
  taken: number;
  takenAbsences: AbsenceInfo[];
};

export type CurrentPeriodSummary = {
  startDate: string;
  endDate: string;
  name: string;
  available: number | null; // null for Unlimited category
  accrued: number | null; // null for Unlimited category
  allowances: AllowanceInfo[] | null; // null for Unlimited category
  taken: number;
  scheduled: number;
  takenAbsences: AbsenceInfo[];
  scheduledAbsences: AbsenceInfo[];
  carriedOverFromPrevYear: CarryOver[];
};

export type NextPeriodSummary = {
  startDate: string;
  endDate: string;
  name: string;
  willAccrue: number | null; // null for Unlimited category
  allowances: AllowanceInfo[] | null; // null for Unlimited category
  scheduled: number;
  scheduledAbsences: AbsenceInfo[];
  upcoming: number;
};

export type CarryOver = {
  amount: number;
  used: number;
  lost: number;
  expired: number;
  expireOn: string | null;
};

export type AbsenceInfo = {
  absenceId: string;
  startDay: string;
  endDay: string;
  amount: number;
};

export type AllowanceInfo = {
  absenceAllowanceId: string;
  accrualPolicyId: string | null;
  amount: number;
  title: string;
};
